export const SANR_DISCORD = 'https://discord.gg/YtqHEYEYTF';
